var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    _vm._l(_vm.changelogList, function (changelog, index) {
      return _c("div", { key: changelog.id }, [
        _c(
          "div",
          { staticClass: "d-none d-lg-block" },
          [
            _c("board-changelog-tooltip", {
              attrs: {
                changelog: changelog,
                "user-details": _vm.userDetails,
                "board-id": _vm.boardId,
                "is-last": _vm.isLast(index),
                origin: _vm.origin,
                "tooltip-trigger": _vm.tooltipTrigger,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-block d-lg-none" },
          [
            _c("board-changelog-collapse", {
              attrs: {
                changelog: changelog,
                "user-details": _vm.userDetails,
                "board-id": _vm.boardId,
                "is-last": _vm.isLast(index),
                origin: _vm.origin,
              },
            }),
          ],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }